import Drawer, { DrawerProps } from '@mui/material/Drawer';

export { Drawer, DrawerProps };
